import React from "react";
import { HelpCircle } from "lucide-react";
import { useLang } from "@/i18n";

// White line-art pictograms per game type (auto-synced via room.gameType).
const GAME_TYPE_PICTO = {
  1: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/wzh6rg03_icon%20knowledge.png",
  2: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/oasfq5tx_pictospeed.png",
  3: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/blk3o1vv_icon%20mosaic.png",
  4: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/p1neisg8_picto%20video.png",
};

const GAME_TYPE_LABEL = {
  1: "Titel & Artiest",
  2: "Wie is het snelst",
  3: "Raad de artiest",
  4: "Videoclip",
};

export const GameTypeBadge = ({ gameType, size = "md", bare = false, className = "", sizeClass }) => {
  const { t: tr } = useLang();
  const picto = GAME_TYPE_PICTO[gameType];
  if (!picto) return null;
  const label = tr(`gtLabel.${gameType}`);

  // Player variant: just the picto, larger, with a white drop shadow — no box, no "?".
  if (bare) {
    const dims = sizeClass || "w-24 h-24 sm:w-28 sm:h-28";
    return (
      <img
        src={picto}
        alt={label}
        title={label}
        draggable={false}
        data-testid="game-type-picto"
        className={`${dims} object-contain select-none ${className}`}
        style={{ filter: "drop-shadow(0 0 10px rgba(255,255,255,0.95)) drop-shadow(0 4px 8px rgba(0,0,0,0.5))" }}
      />
    );
  }

  const dims = size === "lg" ? "w-9 h-9 sm:w-11 sm:h-11" : "w-7 h-7 sm:w-8 sm:h-8";
  return (
    <div
      data-testid="game-type-badge"
      title={label}
      className={`inline-flex items-center gap-2 bg-navy/60 backdrop-blur-md border-2 border-white/40 rounded-full px-3 py-1.5 shadow-[0_6px_16px_rgba(0,0,0,0.35)] ${className}`}
    >
      <HelpCircle className="w-4 h-4 sm:w-5 sm:h-5 text-cream shrink-0" strokeWidth={2.5} />
      <img
        src={picto}
        alt={label}
        draggable={false}
        data-testid="game-type-picto"
        className={`${dims} object-contain select-none`}
        style={{ filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.55))" }}
      />
      <span className="font-bebas text-white text-white-shadow uppercase tracking-wide text-sm sm:text-base whitespace-nowrap">
        {label}
      </span>
    </div>
  );
};
